import { diwali2026PromoCampaign } from './diwali-2026';
import { halloween2026PromoCampaign } from './halloween-2026';
import { octFlash2026PromoCampaign } from './oct-flash-2026';
import { resolveActivePromoCampaignFromList } from './resolve-active-promo-campaign';
import type { ActivePromoCampaign, PromoCampaignContext, RegisteredPromoCampaign } from './types';

export { resolveActivePromoCampaignFromList } from './resolve-active-promo-campaign';

export const PROMO_CAMPAIGNS: RegisteredPromoCampaign[] = [
  diwali2026PromoCampaign,
  halloween2026PromoCampaign,
  octFlash2026PromoCampaign,
];

export function resolveActivePromoCampaign(ctx: PromoCampaignContext): ActivePromoCampaign | null {
  return resolveActivePromoCampaignFromList(PROMO_CAMPAIGNS, ctx);
}
